import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { CustomEventService } from "@shared/services/custom-event.service";
import { AdminService } from "@shared/services/admin.service";

import ActionTypesEnum from "@shared/enums/action-constant.enum";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: "app-add-user-from-LDAP",
  templateUrl: "./add-user-from-LDAP.component.html"
})
export class AddUserFromLDAPComponent implements OnInit, OnDestroy {
  currentStepIndex = 0;
  @Input() buttonLoading: boolean;

  @Input() LDAPGroups: any;
  LDAPUsers: any = [];
  transferGroups: any = [];
  transferUsers: any = [];
  loading: boolean;


  constructor(private adminService: AdminService,
              private customEventService: CustomEventService) {
  }

  async ngOnInit() {
    this.loading = true;
    try {
      await this.init();
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      this.loading = false;
    }
  }
  async init() {
    this.LDAPGroups.sourceGroups.forEach(item => {
      this.transferGroups.push(item);
    });
    this.LDAPGroups.targetGroups.forEach(item => {
      this.transferGroups.push(item);
    });
  }
  async changeStep(type: string): Promise<void> {
    switch (type) {
      case "create":
        this.createLDAPUsers();
        this.cancelForm();
        break;

      case "next":
        await this.getUsers();
        this.currentStepIndex = ++this.currentStepIndex;
        break;

      case "previous":
        this.currentStepIndex = --this.currentStepIndex;
        break;
    }
  }

  createLDAPUsers(): void {
    const formUserData = {
      targetUsers: this.transferUsers.filter((item) => item.direction === "right")
        .map((item) => ({
        baseDn: item.baseDn,
        email: item.email,
        name: item.name,
        surname: item.surname,
        username: item.username,
        ldapKey: item.ldapKey
      })),
      sourceUsers: this.transferUsers.filter((item) => item.direction === "left")
        .map((item) => ({
        baseDn: item.baseDn,
        email: item.email,
        name: item.name,
        surname: item.surname,
        username: item.username,
        ldapKey: item.ldapKey
      }))
    };

    this.customEventService.announceEvent(ActionTypesEnum.UPDATE_LDAP, formUserData);
  }

  getUsers() {
    return new Promise(resolve => {
      const formData = {
        sourceGroups: this.transferGroups.filter((item) => item.direction === "left")
          .map((item) => ({
          key: item.key,
          label: item.label
        })),
        targetGroups: this.transferGroups.filter((item) => item.direction === "right")
          .map((item) => ({
          key: item.key,
          label: item.label
        }))
      };

      this.adminService.createLDAPGroupsOfUsers(formData).pipe(untilDestroyed(this))
        .subscribe(response => {
          response.sourceUsers = response.sourceUsers.map(item => {
            return {
              ...item,
              direction: "left"
            };
          });
          response.targetUsers = response.targetUsers.map(item => {
            return {
              ...item,
              direction: "right"
            };
          });

          resolve(this.LDAPUsers = response);

          this.LDAPUsers.sourceUsers.forEach(item => {
            if (this.transferUsers.length <= this.LDAPUsers.sourceUsers.length) {
              this.transferUsers.push(item);
            } else {
              return;
            }
          });
          this.LDAPUsers.targetUsers.forEach(data => {
            if (this.transferUsers.length < this.LDAPUsers.targetUsers.length
              + this.LDAPUsers.sourceUsers.length) {
              this.transferUsers.push(data);
            } else {
              return;
            }
          });
        });
    });
  }

  nzFilterGroupOption(inputValue: string, item: any) {
    return item.label.toLowerCase().includes(inputValue.toLowerCase());
  }

  nzFilterUserOption(inputValue: string, item: any) {
    return item.username.toLowerCase().includes(inputValue.toLowerCase());
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  ngOnDestroy(): void {
    // prevent memory leak when component destroyed
  }

}
